import { BCMSDefaultModel, BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import AuthorizedDevicesPage from "components/pages/AuthorizedDevicesPage";
import Classes, { MobileDevice } from "model";

export default function CaptureMabiFaceIDDeviceList(props) { 
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const device = MobileDevice.init({
        name: "George's IPhone",
        userID: "georgew",
        password: "12345678",
        isEnrolled: true,
        id: 100
    });
    const defaultDevice = BCMSDefaultModel.mobileDevice();
    const merge = BCMSDefaultModel.mergeRecords(device, defaultDevice);

    MobileDevice.create(merge)
        .submit(Classes);

    return <AuthorizedDevicesPage /> 
}